import { useQuery } from '@tanstack/react-query';
import { buscarStatusRoboApi } from '../api/BuscarStatusRoboApi';
import { hasGestorSelecionado } from '../api/shared';

const UM_MINUTO_MS = 60_000;

export function useBuscarStatusRobo() {
  return useQuery({
    queryKey: ['relatorios', 'status-robo'],
    queryFn: buscarStatusRoboApi,
    refetchInterval: UM_MINUTO_MS,
    staleTime: UM_MINUTO_MS,
    enabled: hasGestorSelecionado(),
  });
}
